import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/classification";

class ClassificationService {

  editclassification(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addclassification(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
  classificationExist(label:string, id : number){
    return axios
      .post(API_URL + '/exist', {label: label, id : id})
      .then(response => {
        return response.data;
      });
  }

  deleteclassification(classificationId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+classificationId)
      .then(response => {
        return response.data;
      });
  }

  


  getclassifications(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


 

}

export default new ClassificationService();